import cookie from 'react-cookie';

export const BRIEFS_FILTER_COOKIE_NAME = 'briefsFilters';

/**
 * Clear the persisted briefs filter cookie and navigate to a clean /jobs URL.
 */
export default function clearJobsFilters(history, cookieApi = cookie) {
  cookieApi.remove(BRIEFS_FILTER_COOKIE_NAME, { path: '/' });
  history.push('/jobs');
}
